import styled from "styled-components";
import Button from "../../../../designComponents/Button";
import Flex from "../../../../designComponents/Flex";
import Modal from "../../../../designComponents/Modal";
import { RenderReviewImages } from "../../../../designComponents/Table/renderMethods";
import Typography from "../../../../designComponents/Typography";
import { toCapitalCase } from "../../../../utils/conversion";
import { AcceptButton, LabelText, SectionTitle, ValueText } from "../styles";
import { ReviewFieldNameType, ReviewReportSend } from "../types";

function ReviewSummary({
  visible,
  onClose,
  reportReview,
  handleSubmitReviews,
  handleClickEdit,
  submitting,
}: {
  visible: boolean;
  onClose: () => void;
  handleSubmitReviews: () => void;
  reportReview: ReviewReportSend[];
  handleClickEdit: (value: ReviewFieldNameType) => void;
  submitting?: boolean;
}) {
  return (
    <Modal isOpen={visible} onClose={onClose} halfWidth title="Review Summary">
      <div style={{ maxHeight: "75vh", overflowY: "auto" }}>
        <Typography>
          Please go through all reviews before submitting all review details.
        </Typography>
        {reportReview &&
          reportReview.map((item, index) => {
            return (
              <CardStyled key={index}>
                <Flex>
                  <SectionTitle>{item.field}</SectionTitle>
                  <Button
                    variant="tag"
                    bgColor="dark.neutral_450"
                    onClick={() => {
                      if (item?.field) {
                        handleClickEdit(item?.field);
                      }
                    }}
                  >
                    Edit
                  </Button>
                </Flex>
                <Flex>
                  <LabelText>Status:</LabelText>
                  <Typography
                    color={
                      item.status === "reject"
                        ? "status.danger"
                        : "status.success"
                    }
                  >
                    {toCapitalCase(item?.status || "")}
                  </Typography>
                </Flex>
                {item.status === "reject" && (
                  <>
                    <Flex direction="column" gap={0}>
                      <LabelText>Description:</LabelText>
                      <ValueText>{item.description}</ValueText>
                    </Flex>
                    <Flex direction="column">
                      <LabelText>Images</LabelText>
                      <Flex wrap="wrap">
                        <RenderReviewImages
                          images={item?.filesFile?.map((x) => x.preview) || []}
                          resize={false}
                        />
                      </Flex>
                    </Flex>
                  </>
                )}
              </CardStyled>
            );
          })}
      </div>
      <div
        style={{ paddingTop: 20, display: "flex", justifyContent: "flex-end" }}
      >
        <AcceptButton
          onClick={handleSubmitReviews}
          isLoading={submitting}
          isDisabled={submitting}
        >
          Submit review
        </AcceptButton>
      </div>
    </Modal>
  );
}

export default ReviewSummary;

const CardStyled = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f0fefd;
  border: 1px solid #dbdbdb;
  gap: 20px;
  border-radius: 10px;
  padding: 20px;
  margin: 14px 0px;
  font-family: Arial, sans-serif;
`;
